import type { FormattedError } from './format-error';
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

import { refreshCSRFToken } from './csrf-token-manager';

const CSRF_HEADER_NAME = 'X-XSRF-TOKEN';
const CSRF_COOKIE_NAME = 'XSRF-TOKEN=';
const MAX_CSRF_RETRIES = 3;

export type CsrfRetryRequestConfig = InternalAxiosRequestConfig & {
  _retryCount?: number;
};

export function attachCsrfRequestInterceptor(instance: AxiosInstance): void {
  instance.interceptors.request.use((config) => {
    const xsrfToken = document.cookie
      .split('; ')
      .find((row) => row.startsWith(CSRF_COOKIE_NAME))
      ?.split('=')[1];

    if (xsrfToken) {
      config.headers[CSRF_HEADER_NAME] = decodeURIComponent(xsrfToken);
    }

    return config;
  });
}

export async function retryInvalidCsrf(
  err: FormattedError,
  originalRequest: CsrfRetryRequestConfig,
  instance: AxiosInstance
) {
  const retryCount = originalRequest._retryCount ?? 0;

  if (!err.data?.invalidCSRF || retryCount >= MAX_CSRF_RETRIES) {
    return null;
  }

  originalRequest._retryCount = retryCount + 1;
  await refreshCSRFToken();

  return instance(originalRequest);
}
